import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cs-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cs-button.component.html',
  styleUrls: ['./cs-button.component.scss'],
})
export class CSButtonComponent implements OnInit {
  /** 按钮的文字 */
  @Input() label = '';

  /**
   * 按钮的顏色
   * primary: 橘色(第一個)
   * secondary: 淺綠(第二個)
   * third: 深綠(最後一個)
   * accent: 銀光綠(第三個)
   * danger: 紅色(第四個)
   */

  @Input() color: 'primary' | 'secondary' | 'third' | 'accent' | 'danger' = 'primary';

  /** 按钮的大小 */
  @Input() size: 'large' | 'default' | 'small' = 'default';

  /** 按钮图标的类型 */
  @Input() iconType: 'icon' | 'image' = 'icon';

  /** 按钮的图标(左) */
  @Input() iconLeft = '';

  /** 按钮的图标(右) */
  @Input() iconRight = '';

  /** 表单的控件寬 */
  @Input() width = '100%';

  /** 表单的控件高 */
  @Input() height = '';

  /** 是否禁用 */
  @Input() disabled = false;

  /** 是否為 loading 狀態 */
  @Input() loading = false;

  @Input() buttonStyle = {};

  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @Output() onReady: EventEmitter<MouseEvent> = new EventEmitter();

  //如果需要disabled狀態的點擊事件，請務必使用 @Output() buttonClick
  //用click事件，disabled狀態下會無法觸發
  @Output() buttonClick = new EventEmitter<MouseEvent>();

  handleClick(event: Event) {
    this.buttonClick.emit(event as MouseEvent);
  }

  // 把 width 綁定到 host 的 style
  @HostBinding('style.width') get hostWidth() {
    return this.width;
  }

  ngOnInit(): void {
    this.onReady.emit();
  }
}
